import type { NavLink, Office, SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'nSure.ai',
    description: 'nSure.ai turns payment fraud prevention into a profit center for crypto, gaming, and prepaid and gift card merchants. Up to 98% approval, decisions in under 500ms and 100% chargeback liability.',
    url: getOrigin(),
    email: 'info@nsure.ai',
    links: {
        linkedin: 'https://www.linkedin.com/company/nsureai/',
        x: 'https://twitter.com/nSureai'
    }
}

export const industryLinks: NavLink[] = [
    { label: 'Crypto', href: '/industry/crypto' },
    { label: 'Gaming', href: '/industry/gaming' },
    { label: 'Prepaid & Gift Cards', href: '/industry/prepaid-cards' }
]

export const companyLinks: NavLink[] = [
    { label: 'About Us', href: '/about-us' },
    { label: 'Careers', href: '/careers' },
    { label: 'Knowledge Hub', href: '/knowledgehub' },
    { label: 'Contact', href: '/contact' }
]

export const legalLinks: NavLink[] = [
    { label: 'Terms & Conditions', href: '/terms-conditions' },
    { label: 'Privacy Policy', href: '/privacy-policy' }
]

export const offices: Office[] = [
    { city: 'New York', short: 'NYC', timeZone: 'America/New_York' },
    { city: 'London', short: 'LDN', timeZone: 'Europe/London' },
    { city: 'Tel Aviv', short: 'TLV', timeZone: 'Asia/Jerusalem' }
]

export const routeLabels: Record<string, string> = {
    '/': 'Home',
    '/industry/crypto': 'Crypto',
    '/industry/gaming': 'Gaming',
    '/industry/prepaid-cards': 'Prepaid & Gift Cards',
    '/about-us': 'About',
    '/careers': 'Careers',
    '/contact': 'Contact',
    '/knowledgehub': 'Knowledge Hub',
    '/privacy-policy': 'Privacy',
    '/terms-conditions': 'Terms'
}
